import type { ComputedRef, Ref } from 'vue';

import type { HomepageInformationResponseDto } from '~/apiClient';

type UseFleequidStatsReturn = {
    soldVehicles: ComputedRef<number>;
    countries: ComputedRef<number>;
    companies: ComputedRef<number>;
    availableVehicles: ComputedRef<number>;
    employees: ComputedRef<number>;
    _raw: {
        apiStats: Ref<HomepageInformationResponseDto | null>;
    };
};

const FALLBACK_API_STATS: HomepageInformationResponseDto = {
    soldVehicles: 1000,
    countries: 70,
    companies: 4000,
};

export const useFleequidStats = (): UseFleequidStatsReturn => {
    const apiStats = useState<HomepageInformationResponseDto | null>('fleequidStats', () => null);

    return {
        soldVehicles: computed(() => roundWithPrecision(apiStats.value?.soldVehicles ?? FALLBACK_API_STATS.soldVehicles, 100)),
        countries: computed(() => roundWithPrecision(apiStats.value?.countries ?? FALLBACK_API_STATS.countries, 10)),
        companies: computed(() => roundWithPrecision(apiStats.value?.companies ?? FALLBACK_API_STATS.companies, 100)),
        availableVehicles: computed(() => roundWithPrecision(700, 100, 'floor')), // TODO: to be replaced with API when available
        employees: computed(() => 70),
        // For exclusive use of the fleequidStats plugin
        _raw: {
            apiStats,
        },
    };
};
